import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import * as wConsts from "../consts/website-consts";
import * as wActs from "../actions/website-actions";
import { FormattedMessage } from "react-intl";
import {Link} from "react-router-dom";
import SwBanner from "../components/swbanner";
import BuyAdBanner from "../components/buyadbanner";
import SeoHeaders from "../components/seoheaders";
import RightBanners from "../components/rightbanners";
import Loading from "../components/loading";
import SelectBox from "../components/selectbox";

class Signup extends Component {

  constructor(props) {
    super(props);
    this.state = {
      regSelect: "block",
      regForm: "none"
    };
  }

  componentDidMount() {
    this.props.dispatch({ type: wConsts.ACTION_SET_PAGETYPE, payload: "signup" });

  }

  handleClick(evt, tType) {
    evt.preventDefault();
    this.props.dispatch({ type: wConsts.SIGNUP_SET_TYPE, payload: tType });
    this.setState({
      regSelect: "none",
      regForm: "block"
    });
  }

  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }

  handleCloseAlert() {
    this.setState({ showingAlert: false });
  }
  handleCloseSuccess() {
    this.setState({ showingSuccess: false });
  }

  handleSubmit(evt) {
    evt.preventDefault();
    const data = {
      "UserName": this.formUsername.value,
      "Password": this.formPassword.value,
      "EmailAddress": this.formEmail.value,
      "Type": this.props.WebPage.SignUp.Type,
      "Source": "escortnews"
    };

    if(data.Type.toLowerCase() == "agent") {
      data.AgentType = this.AgentType.state.value.value;
    }

    //console.log("Data To Post", data);


    this.props.dispatch(wActs.Signup(data,this.props.history, wActs.getCultPath(this.props.WebPage,"/confirm")));
  }

  PopupCenter(url, title, w, h) {
    const dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;

    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    const left = ((width / 2) - (w / 2)) + dualScreenLeft;
    const top = ((height / 2) - (h / 2)) + dualScreenTop;
    const newWindow = window.open(url, title, 'toolbar=0,scrollbars=0,location=0,statusbar=0,menubar=0,resizable=0, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (window.focus) {
      newWindow.focus();
    }

    return newWindow;
  }


  showWarning(txt,e) {
    e.preventDefault();
    this.props.dispatch(wActs.showWarning("WARN",txt))
  }

  handleENewsClick(evt) {
    evt.preventDefault();
    this.PopupCenter("https://auth.escortnews.eu/auth/login", "loginWindow", 410, 515);
    window.addEventListener("message", function (event) {
      if (event.origin.toLowerCase().indexOf("auth") > 0) {
        if (event.data.token_type === "Bearer") {
          let domain = "." + wActs.getSubdomain(window.location.hostname);
          wActs.setCookie("auth", event.data.access_token, { path: "/", maxAge: 31557600, domain: domain });
          window.location = "/";
        }
      } else {
        console.log("Bad Origin", event);
      }
    }, false);
  }



  render() {

    if(!this.props.WebPage.PageLoaded) {
      return (
        <Loading/>
      );
    }


    let centerBan = "four-center-banner";
    let showBan = this.props.WebPage.Settings.ShowRightBanners;
    let agLabel = this.getTranslation("page.signup.agencycompany");
    let isAdult = wActs.isAdult(this.props.WebPage);

    if(this.props.WebPage.Settings.AgentSignupKey) {
      agLabel = this.getTranslation(this.props.WebPage.Settings.AgentSignupKey,"Agency / Studio / Club");
    }
    return (

      <div className="content-wrap">
        <SeoHeaders Position={"Top"}/>
          <div className={`cell ${showBan ? "x9" : "x12"}`}>
            <div className="white-wrap the-content">
            <div id="register-select" style={{background: "#fff", display: this.state.regSelect, padding: "5px"}}>



              <div className="forms-tabs tabsjquery tab">
                <ul>
                  <li><a href="#" onClick={(e) => { this.handleClick(e, "agent"); }} className="tablinks" data-value="tab1"><img src="/imgs/member.jpg" alt={"Webmaster"}/><span>Webmaster</span></a></li>
                  <li><a href="#" onClick={(e) => { this.handleClick(e, "independentmodel"); }} className="tablinks" data-value="tab2"><img src="/imgs/model.jpg" alt={this.getTranslation("page.signup.independentmodel")}/><span>{this.getTranslation("page.signup.independentmodel")}</span></a></li>
                  <li><a href="#" onClick={(e) => { this.handleClick(e, "agent"); }} className="tablinks" data-value="tab3"><img src="/imgs/agency.jpg" alt={agLabel}/><span>{agLabel}</span></a>
                  </li>
                </ul>
              </div>


              <div className="tac account-urls">
                <p><FormattedMessage id={"page.signup.alreadyhaveaccount"}>{(...content) => content}</FormattedMessage>&nbsp;&nbsp;&nbsp;<Link to={wActs.getCultPath(this.props.WebPage,"/login")} title=""><FormattedMessage id={"page.signup.loginhere"}>{(...content) => content}</FormattedMessage></Link></p>
                <a href="#" onClick={(e) => this.handleENewsClick(e)} className="dark-btn">{this.getTranslation("page.login.loginwithyourescortnewsaccount")}</a>
              </div>




            </div>
          <div id="register-form">
              <form>
              <div id="register-popup" className="thin-form wpadding mta" style={{background: "#fff", display: this.state.regForm }}>

                  <p><i><FormattedMessage id={"page.signup.alreadyhaveaccount"}>{(...content) => content}</FormattedMessage> <Link to={wActs.getCultPath(this.props.WebPage,"/login")} title=""><FormattedMessage id={"page.signup.loginhere"}>{(...content) => content}</FormattedMessage></Link></i></p>

                {this.props.SignUp.Type == "agent" &&
                <div className="input-block" style={{marginBottom: "7px"}}>
                  <label><FormattedMessage id={"dash.type"}>{(...content) => content}</FormattedMessage></label>
                  <SelectBox options={this.props.AgentTypes} ref={(r)=>{this.AgentType = r}}
                             defaultValue={this.props.DefaultType}
                  />
                </div>
                }

                <div className="input-block">
                    <label><FormattedMessage id={"page.email"}>{(...content) => content}</FormattedMessage></label>
                    <input ref={(ref) => { this.formEmail = ref; }} type="email" name="" placeholder="example@gmail.com" />
                  </div>

                  <div className="input-block">
                    <label><FormattedMessage id={"page.login.username"}>{(...content) => content}</FormattedMessage></label>
                    <input ref={(ref) => { this.formUsername = ref; }} type="text" name="" placeholder={this.getTranslation("page.login.username")} />
                  </div>

                  <div>
                    <label><FormattedMessage id={"page.login.password"}>{(...content) => content}</FormattedMessage></label>
                    <input ref={(ref) => { this.formPassword = ref; }} type="password" name="" placeholder="" />
                  </div>

                  <div>
                    <label><FormattedMessage id={"page.signup.confirmpassword"}>{(...content) => content}</FormattedMessage></label>
                    <input ref={(ref) => { this.formPasswordC = ref; }} type="password" name="" placeholder="" />
                  </div>
                  {this.props.WebPage.SignUp.Status !== wConsts.SIGNUP_STATUS_PENDING &&
                  <input type="submit" onClick={(evt) => { this.handleSubmit(evt); }} className="button full" name="" value={this.getTranslation("page.submit")}/>
                  }
                  {this.props.WebPage.SignUp.Status === wConsts.SIGNUP_STATUS_PENDING &&
                  <img src={"/imgs/loader.gif"} width={"75"} height={"75"} alt={"loading..."} style={{ margin: "auto", contentAlign: "center", justifyContent: "center", display: "flex" }} />
                  }

                  <p className="centered-content" style={{minHeight: "50px"}}>&nbsp;</p>
                  <div className="tac account-urls">
                    <p><FormattedMessage id={"page.signup.alreadyhaveaccount"}>{(...content) => content}</FormattedMessage>&nbsp;&nbsp;&nbsp;<Link to={wActs.getCultPath(this.props.WebPage,"/login")} title=""><FormattedMessage id={"page.signup.loginhere"}>{(...content) => content}</FormattedMessage></Link></p>
                    {isAdult && <a href="#" onClick={(e) => {this.handleENewsClick(e)}} className="dark-btn">{this.getTranslation("page.login.loginwithyourescortnewsaccount")}</a> }
                  </div>

              </div>
            </form>
          </div>


          {isAdult && <div className="footer-text" style={{background: "white", padding: "15px"}} ><pre dangerouslySetInnerHTML={{__html: this.getTranslation("page.footer.thebiggestnetworkintheworld")}}></pre></div> }
          <div className={"flex-center"} style={{background: "white"}}>
            <div className={centerBan}>
              <SwBanner apiAnonId={this.props.WebPage.Request.AnonymousId} tagText={this.props.WebPage.Settings.HtmlSections['Adserver-300x100-ournetwork']} className={"network-banners"} ApiReferer={this.props.WebPage.ServerParams.Referer}>
                <BuyAdBanner size={"300x100"} hideBottom={true} textButton={"Advertise here!"} textButton={this.getTranslation("page.advertise.advertisehere")} textTop={this.getTranslation("page.advertise.getxtimesmorevisitors")} textBottom={this.getTranslation("page.advertise.buyabanneraddtoday")}/>
              </SwBanner>
            </div>
          </div>
          <div style={{width: "100%", background: "white", height: "40px"}}></div>
          </div>
        </div>

        {showBan &&
        <div className="cell x3">
          <RightBanners/>
        </div>
        }

        <SeoHeaders Position={"Bottom"}/>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    SignUp: state.Website.SignUp,
    AgentTypes: state.Website.Lists.filter((t) => { return t.group == "AgentType" && t.value !== "Unknown" }).map((t) => { return { value: t.value, label: t.displayValue } }),
    DefaultType: state.Website.Lists.filter((t) => { return t.group == "AgentType" && t.value == "EscortAgency" }).map((t) => { return { value: t.value, label: t.displayValue } })[0],
  };
};

export default connect(mapStateToProps)(Signup);
